import getRequestParams from '../utilities/get-request-params';

const showDemoForm = {
    forms: [],

    showForm(form) 
    {
        var hideOverlay = function(form) {
            form.container.classList.remove('is-visible');
            document.body.classList.remove('has-overlay');
        }

        if( form.email.value !== '' && form.email.value.indexOf('@') !== -1 )
        {
            let src = 'https://insights.aimms.com/l/365141/2020-03-11/csx5p?email=' + form.email.value;

            const requestParams = getRequestParams();
            
            const params = [];

            if( requestParams.utm_source )   params.push('utm_source=' + requestParams.utm_source);
            if( requestParams.utm_medium )   params.push('utm_medium=' + requestParams.utm_medium);
            if( requestParams.utm_campaign ) params.push('utm_campaign=' + requestParams.utm_campaign);

            if( params.length )
            {
                src += '&' + params.join('&');
            }

            form.container.classList.add('is-visible');
            form.iframe.src = src;
            
            document.body.classList.add('has-overlay');

            document.addEventListener('click', function(e){ hideOverlay(form) }, true);
            document.addEventListener('keyup', function(e){ if( e.keyCode === 27 ) hideOverlay(form) }, true);
        }
    },

    bind()
    {
        this.forms.forEach( function(form) {
            form.button.addEventListener('click', function() { 
                this.showForm(form)
            }.bind(this) );
        }.bind(this));
    },

    cacheDom()
    {
        const instances = document.querySelectorAll('.js-demo-popup');

        if( instances )
        {
            [].forEach.call( instances, instance => {
                const form = {
                    button: instance.querySelector('.js-demo-popup-show-form'),
                    email: instance.querySelector('.js-demo-popup-email'),
                    container: instance.querySelector('.js-demo-popup-container'),
                    iframe: instance.querySelector('iframe')
                }

                this.forms.push(form);
            });
        }
    },

    init() 
    {
        this.cacheDom();
        if( this.forms.length )
        {
            this.bind();
        }
    }
}

export default showDemoForm;